import { FlexRow } from '@gorila-shared-ui/components';
import { LabelXSmall } from 'baseui/typography';
import { memo } from 'react';
import { useStyles } from '../../hooks/useStyles';

type Props = {
  gbConsumed?: number;
  percentageConsumed?: number;
  fillWidth?: boolean;
  withVerticalWhiteSpace?: boolean;
};

function ConsumptionLabel({
  gbConsumed,
  percentageConsumed,
  fillWidth = false,
  withVerticalWhiteSpace = false,
}: Readonly<Props>) {
  const { css, theme } = useStyles();
  const wrapperStyles = css({
    padding: `${withVerticalWhiteSpace ? theme.sizing.scale200 : theme.sizing.scale100} ${theme.sizing.scale300}`,
    background: theme.colors.backgroundSecondary,
    borderRadius: theme.borders.radius200,
    width: fillWidth ? '100%' : 'auto',
  });
  const wrapperProps = {
    classNames: wrapperStyles,
    gap: theme.sizing.scale100,
    centered: true,
  };

  if (gbConsumed === undefined || percentageConsumed === undefined) {
    return null;
  }

  const color = (() => {
    if (percentageConsumed <= 40) return theme.colors.contentPositive;
    if (percentageConsumed > 40 && percentageConsumed <= 75) return theme.colors.contentWarning;
    return theme.colors.contentNegative;
  })();

  return (
    <FlexRow {...wrapperProps}>
      <LabelXSmall
        color={color}
        style={{ whiteSpace: 'nowrap', transition: 'color 0.3s ease-in-out' }}
      >
        {Intl.NumberFormat().format(+gbConsumed.toFixed(2))} GB
      </LabelXSmall>
    </FlexRow>
  );
}

export default memo(ConsumptionLabel);
